import React, {useState} from 'react'
import { Link, useParams } from 'react-router-dom';
import Posts from '../data/data-destination.json';
import Modal from '../Gallery/Modal';
import { companyInfo } from '../data/companyInfo';

function DestinationDetailsMain() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const { id } = useParams();
    const destinationPost = Posts.find(post => post.id === parseInt(id));

    if (!destinationPost) {
        return <div>Post not found!</div>;
    }

    const destinationDetails = {
        1: {
            heading: 'Skardu Valley Blossom Escape',
            overviewOne: 'Skardu Valley is the heart of Baltistan, famous for snow-capped peaks, turquoise lakes, and colorful blossom views in spring. This package is perfect for families, couples, and adventure lovers who want scenic beauty with comfortable travel.',
            overviewTwo: 'The tour covers Shangri-la Resort, Upper Kachura Lake, Manthoka Waterfall, Chunda Valley, Sarfaranga Cold Desert, and Shigar Fort. Travel is arranged in luxury Prado/TZ vehicles with professional local support throughout your journey.',
            basicIntro: 'Best season is March to April for blossom views and pleasant weather. Tour timings may be adjusted according to weather and road conditions.',
            area: '80,000+ kmÂ² (Baltistan region)',
            sitesCount: '6+ major attractions',
            quote: 'From lakes to deserts in one valley, Skardu offers a complete mountain experience for every traveler.',
            highlights: [
                'Shangri-la Resort and Upper Kachura Lake visit',
                'Manthoka Waterfall and Chunda Valley blossom views',
                'Sarfaranga Cold Desert off-road experience',
                'Historic Shigar Fort cultural tour',
                'Luxury Prado/TZ transport and expert guide',
                'Breakfast, dinner, bonfire/BBQ, and hotel stays',
                'Music system and basic first aid support'
            ]
        },
        2: {
            heading: 'Hunza Valley Cherry Blossom Tour',
            overviewOne: 'Hunza Valley is known worldwide for dramatic landscapes, warm hospitality, and historic forts. During cherry blossom season, the valley transforms into pink and white gardens beneath giant mountain peaks.',
            overviewTwo: 'This package includes Duikar Eagle Nest, Rakaposhi View Point, Baltit Fort, and Altit Fort. It is ideal for travelers who want cultural history, scenic photography, and relaxed luxury travel in one trip.',
            basicIntro: 'Mid-March to April-end is the prime cherry blossom period in Hunza and Nagar. Advance booking is strongly recommended.',
            area: '10,100+ kmÂ² (Hunza district)',
            sitesCount: '5+ major attractions',
            quote: 'Hunza is not just a destination, it is a feeling of peace, culture, and mountain magic.',
            highlights: [
                'Duikar Eagle Nest sunset viewpoint',
                'Rakaposhi View Point stopover',
                'Guided visits of Baltit Fort and Altit Fort',
                'Dedicated car with professional driver',
                'Reputed hotel stay with breakfast',
                'Perfect weather for photography and family trips',
                'Customizable private itinerary'
            ]
        },
        3: {
            heading: 'Fairy Meadows & Nanga Parbat Experience',
            overviewOne: 'Fairy Meadows is one of Pakistan\'s most iconic alpine destinations, offering unmatched views of Nanga Parbat. It is a dream destination for trekkers, campers, and nature enthusiasts.',
            overviewTwo: 'This experience combines mountain adventure with peaceful meadows, starry skies, and local hospitality. It is best suited for active travelers seeking a true high-altitude nature escape.',
            basicIntro: 'Recommended season is late spring to early autumn. Trekking days require moderate fitness and weather flexibility.',
            area: '15,000+ kmÂ² (Diamer region coverage)',
            sitesCount: '4+ core adventure points',
            quote: 'At Fairy Meadows, every sunrise over Nanga Parbat feels like a lifetime memory.',
            highlights: [
                'Fairy Meadows scenic jeep and trekking route',
                'Panoramic views of Nanga Parbat',
                'Bonfire and outdoor camping atmosphere',
                'Professional local guide and safety support',
                'Comfortable arranged stays where available',
                'Photography-friendly mountain landscapes',
                'Adventure-focused custom pacing'
            ]
        },
        4: {
            heading: 'Naltar Valley Alpine Lakes Tour',
            overviewOne: 'Naltar Valley is famous for colorful alpine lakes, forests, and mountain meadows. It is a compact but highly scenic destination, ideal for short premium getaways.',
            overviewTwo: 'The route offers off-road excitement with relaxing nature views. In every season, Naltar gives a refreshing break from city life and a clean mountain atmosphere.',
            basicIntro: 'Naltar is accessible with suitable transport planning. Short-duration private tours are most popular for this destination.',
            area: '1,500+ kmÂ² (Naltar and surrounding belt)',
            sitesCount: '3+ major viewpoints/lakes',
            quote: 'Naltar proves that even a short mountain trip can feel extraordinary.',
            highlights: [
                'Visit to famous Naltar lakes',
                'Alpine forest and valley sightseeing',
                'Private transport and dedicated driver',
                'Professional local support',
                'Comfortable hotel arrangements',
                'Family-friendly short itinerary',
                'Optional extension to nearby valleys'
            ]
        },
        5: {
            heading: 'Upper Hunza (Gojal) Explorer',
            overviewOne: 'Upper Hunza, also called Gojal, is known for Attabad Lake, Passu Cones, Hussaini Bridge, and the route to Khunjerab Pass. It offers one of the most scenic drives in Pakistan.',
            overviewTwo: 'This tour is ideal for travelers who want iconic landmarks, adventure roads, and unforgettable mountain panoramas in a single trip.',
            basicIntro: 'Road conditions and weather can vary, especially near high-altitude zones. Plans remain flexible for safety and comfort.',
            area: '9,000+ kmÂ² (Gojal belt)',
            sitesCount: '6+ major attractions',
            quote: 'Upper Hunza is where glaciers, lakes, and high passes meet in one unforgettable route.',
            highlights: [
                'Attabad Lake and Passu Cones viewpoints',
                'Hussaini Suspension Bridge stop',
                'Drive toward Khunjerab Pass (Pak-China border)',
                'Sost and Upper Hunza cultural exploration',
                'Luxury transport with experienced team',
                'Flexible photography and stopover schedule',
                'Custom family/couple itinerary options'
            ]
        },
        6: {
            heading: 'Shigar Valley Heritage Journey',
            overviewOne: 'Shigar Valley blends history and natural beauty, offering a peaceful escape near Skardu. The valley is especially known for the iconic Shigar Fort and traditional Balti culture.',
            overviewTwo: 'This package is ideal for travelers who prefer a balanced mix of cultural exploration, mountain scenery, and comfortable stays.',
            basicIntro: 'Shigar can be covered as a standalone package or paired with Skardu for a broader Baltistan experience.',
            area: '8,500+ kmÂ² (Shigar district)',
            sitesCount: '4+ key attractions',
            quote: 'In Shigar, every stone fort and valley road reflects the timeless spirit of Baltistan.',
            highlights: [
                'Guided Shigar Fort visit',
                'Balti culture and heritage exploration',
                'Scenic valleys and riverside viewpoints',
                'Private luxury transport service',
                'Comfortable hotel accommodations',
                'Breakfast/dinner support',
                'Easy add-on with Skardu itinerary'
            ]
        },
        7: {
            heading: 'Deosai National Park Adventure',
            overviewOne: 'Deosai National Park, known as the Land of Giants, is one of the highest plateaus in the world. It offers vast meadows, wild landscapes, and unmatched panoramic views.',
            overviewTwo: 'The Deosai tour is perfect for nature lovers and road-trip adventurers looking for a raw and unforgettable high-altitude experience.',
            basicIntro: 'Deosai is season-sensitive and mainly visited in open months. Weather shifts quickly, so flexible planning is important.',
            area: '3,000+ kmÂ² (Deosai plateau)',
            sitesCount: '4+ prime stops',
            quote: 'Deosai is where the sky feels closer and nature feels infinite.',
            highlights: [
                'Entry into Deosai National Park',
                'Sheosar Lake and plateau viewpoints',
                'High-altitude road adventure',
                'Private Prado/TZ transport',
                'Guide support for safe routing',
                'Photography-focused stopovers',
                'Short premium nature escape'
            ]
        },
        8: {
            heading: 'Nagar Valley Blossom & Glacier Tour',
            overviewOne: 'Nagar Valley is a top spring destination with cherry blossom scenery, glacier viewpoints, and traditional mountain villages. It is often combined with Hunza for a complete northern experience.',
            overviewTwo: 'This itinerary includes Hopper Valley and cultural spots, making it ideal for explorers who want both landscape and heritage.',
            basicIntro: 'Peak blossom months are mid-March to April-end. Multi-day private road tours are highly recommended for Nagar.',
            area: '7,500+ kmÂ² (Nagar district)',
            sitesCount: '5+ major attractions',
            quote: 'Nagar Valley brings together blossoms, glaciers, and living mountain culture in one route.',
            highlights: [
                'Hopper Valley and glacier viewpoints',
                'Ganish and heritage settlement visits',
                'Cherry blossom scenic drives',
                'Dedicated driver and fuel/tolls covered',
                'Reputed hotel stay with breakfast',
                'Balanced road itinerary with rest stops',
                'Best for spring photography tours'
            ]
        },
        9: {
            heading: 'Gilgit City Gateway Tour',
            overviewOne: 'Gilgit City is the gateway to northern Pakistan and a key stop for travelers heading to Hunza, Skardu, and Nagar. It offers local culture, bazaars, and easy access to surrounding valleys.',
            overviewTwo: 'This short package suits travelers seeking a comfortable entry/exit plan, city orientation, and quick sightseeing before extended valley tours.',
            basicIntro: 'Gilgit can be booked as a short city break or as part of a longer multi-destination package.',
            area: '38,000+ kmÂ² (Gilgit division linkage)',
            sitesCount: '3+ city and nearby attractions',
            quote: 'Every northern journey begins with Gilgit, the true gateway to mountain adventures.',
            highlights: [
                'Airport pickup/drop and city transfer support',
                'Local market and cultural stopovers',
                'Nearby scenic points around Gilgit',
                'Private transport with driver',
                'Comfortable hotel stay options',
                'Smooth connection to Hunza/Skardu plans',
                'Ideal short-duration itinerary'
            ]
        }
    };

    const selectedDetails = destinationDetails[destinationPost.id] || destinationDetails[1];

    const destinationGalleries = {
        1: ['destination_1_1.jpg', 'destination_1_2.jpg', 'destination_1_3.jpg', 'destination_1_4.jpg'],
        2: ['destination_2_1.jpg', 'destination_2_2.jpg', 'destination_2_3.jpg', 'destination_2_4.jpg'],
        3: ['destination_3_1.jpg', 'destination_3_2.jpg', 'destination_3_3.jpg', 'destination_3_4.jpg'],
        4: ['destination_4_1.jpg', 'destination_4_2.jpg', 'destination_4_3.jpg', 'destination_4_4.jpg'],
        5: ['destination_5_1.jpg', 'destination_5_2.jpg', 'destination_5_3.jpg', 'destination_8_1.jpg'],
        6: ['destination_6_1.jpg', 'destination_6_2.jpg', 'destination_6_3.jpg', 'destination_6_4.jpg'],
        7: ['destination_7_1.jpg', 'destination_7_2.jpg', 'destination_7_3.jpg', 'destination_9_1.jpg'],
        8: ['destination_8_1.jpg', 'destination_8_2.jpg', 'destination_8_3.jpg', 'destination_9_2.jpg'],
        9: ['destination_9_1.jpg', 'destination_9_2.jpg', 'destination_9_3.jpg', 'destination_9_4.jpg']
    };

    const destinationReviews = {
        1: [
            {
                name: 'Ahmad Raza',
                date: '12 Apr, 2025',
                time: '07:30pm',
                text: 'Skardu Blossom package bohat zabardast tha. Shangri-la, Kachura Lake aur Shigar Fort sab perfectly planned thay.',
                avatar: '/assets/img/blog/comment-author-1.jpg'
            },
            {
                name: 'Sara Malik',
                date: '18 Apr, 2025',
                time: '06:00pm',
                text: 'Chunda Valley aur Sarfaranga Cold Desert ka experience outstanding tha. Team ne full support diya.',
                avatar: '/assets/img/blog/comment-author-4.jpg'
            },
            {
                name: 'Bilal Khan',
                date: '25 Apr, 2025',
                time: '09:15pm',
                text: 'Luxury Prado, hotel stay aur food quality bohat achi thi. Family ke sath best trip rahi.',
                avatar: '/assets/img/blog/comment-author-5.jpg'
            }
        ],
        2: [
            {
                name: 'Usman Tariq',
                date: '16 Mar, 2025',
                time: '08:10pm',
                text: 'Hunza cherry blossom tour dream trip rahi. Baltit aur Altit Fort guided visit bohat informative thi.',
                avatar: '/assets/img/blog/comment-author-1.jpg'
            },
            {
                name: 'Ayesha Noor',
                date: '20 Mar, 2025',
                time: '05:50pm',
                text: 'Duikar Eagle Nest sunset aur Rakaposhi viewpoint unforgettable thay. Management excellent thi.',
                avatar: '/assets/img/blog/comment-author-4.jpg'
            },
            {
                name: 'Kamran Hussain',
                date: '24 Mar, 2025',
                time: '09:05pm',
                text: 'Dedicated car aur driver ki wajah se trip bohat comfortable rahi. Highly recommended for couples.',
                avatar: '/assets/img/blog/comment-author-5.jpg'
            }
        ],
        3: [
            {
                name: 'Hamza Ali',
                date: '10 Jun, 2025',
                time: '07:10pm',
                text: 'Fairy Meadows trek challenging tha lekin view of Nanga Parbat bilkul worth it tha.',
                avatar: '/assets/img/blog/comment-author-1.jpg'
            },
            {
                name: 'Hira Faisal',
                date: '12 Jun, 2025',
                time: '06:40pm',
                text: 'Bonfire night aur mountain camp life ka experience next level tha.',
                avatar: '/assets/img/blog/comment-author-4.jpg'
            },
            {
                name: 'Talha Mehmood',
                date: '15 Jun, 2025',
                time: '09:00pm',
                text: 'Guide bohat cooperative tha aur pura route safely cover karwaya.',
                avatar: '/assets/img/blog/comment-author-5.jpg'
            }
        ],
        4: [
            {
                name: 'Danish Iqbal',
                date: '05 Jul, 2025',
                time: '07:25pm',
                text: 'Naltar lakes ke colors reality mein aur bhi zyada beautiful lage.',
                avatar: '/assets/img/blog/comment-author-1.jpg'
            },
            {
                name: 'Maryam Ahmed',
                date: '08 Jul, 2025',
                time: '05:45pm',
                text: 'Short trip ke liye perfect package tha. Har stop planned tha.',
                avatar: '/assets/img/blog/comment-author-4.jpg'
            },
            {
                name: 'Fahad Rehman',
                date: '09 Jul, 2025',
                time: '08:55pm',
                text: 'Family ke sath bohat peaceful aur safe tour experience raha.',
                avatar: '/assets/img/blog/comment-author-5.jpg'
            }
        ],
        5: [
            {
                name: 'Shahzad Khan',
                date: '02 Aug, 2025',
                time: '07:15pm',
                text: 'Upper Hunza route, Attabad Lake aur Passu Cones sab iconic spots cover hue.',
                avatar: '/assets/img/blog/comment-author-1.jpg'
            },
            {
                name: 'Iqra Saeed',
                date: '04 Aug, 2025',
                time: '06:25pm',
                text: 'Hussaini Bridge aur Khunjerab Pass ka day trip adventurous tha.',
                avatar: '/assets/img/blog/comment-author-4.jpg'
            },
            {
                name: 'Adnan Qureshi',
                date: '06 Aug, 2025',
                time: '09:20pm',
                text: 'Photographers ke liye perfect itinerary thi. Team was very professional.',
                avatar: '/assets/img/blog/comment-author-5.jpg'
            }
        ],
        6: [
            {
                name: 'Saad Karim',
                date: '14 Sep, 2025',
                time: '07:35pm',
                text: 'Shigar Fort visit ka historical perspective bohat informative tha.',
                avatar: '/assets/img/blog/comment-author-1.jpg'
            },
            {
                name: 'Anum Zahra',
                date: '15 Sep, 2025',
                time: '06:15pm',
                text: 'Balti culture ko close se dekhne ka moka mila, great local experience.',
                avatar: '/assets/img/blog/comment-author-4.jpg'
            },
            {
                name: 'Tariq Bashir',
                date: '17 Sep, 2025',
                time: '08:45pm',
                text: 'Relaxed and comfortable trip thi, especially for family travelers.',
                avatar: '/assets/img/blog/comment-author-5.jpg'
            }
        ],
        7: [
            {
                name: 'Haris Waheed',
                date: '20 Jun, 2025',
                time: '07:00pm',
                text: 'Deosai plateau ka landscape unreal lagta hai. Sheosar Lake was stunning.',
                avatar: '/assets/img/blog/comment-author-1.jpg'
            },
            {
                name: 'Rabia Javed',
                date: '21 Jun, 2025',
                time: '06:35pm',
                text: 'Road trip adventurous thi aur guide ne har point detail se explain kiya.',
                avatar: '/assets/img/blog/comment-author-4.jpg'
            },
            {
                name: 'Nabeel Aslam',
                date: '22 Jun, 2025',
                time: '09:10pm',
                text: 'Nature lovers ke liye Deosai must-visit hai, trip bohat smooth rahi.',
                avatar: '/assets/img/blog/comment-author-5.jpg'
            }
        ],
        8: [
            {
                name: 'Adeel Hassan',
                date: '11 Apr, 2025',
                time: '07:20pm',
                text: 'Nagar blossom season amazing thi, Hopper Valley views unforgettable thay.',
                avatar: '/assets/img/blog/comment-author-1.jpg'
            },
            {
                name: 'Mahnoor Ali',
                date: '13 Apr, 2025',
                time: '06:10pm',
                text: 'Road itinerary balanced thi aur hotels bohat achay arrange kiye gaye.',
                avatar: '/assets/img/blog/comment-author-4.jpg'
            },
            {
                name: 'Rizwan Ahmed',
                date: '15 Apr, 2025',
                time: '08:50pm',
                text: 'Nagar aur Hunza combo best nikla, value for time bohat high thi.',
                avatar: '/assets/img/blog/comment-author-5.jpg'
            }
        ],
        9: [
            {
                name: 'Imran Yousaf',
                date: '03 May, 2025',
                time: '07:05pm',
                text: 'Gilgit city transfer and stay arrangements bohat smooth thay.',
                avatar: '/assets/img/blog/comment-author-1.jpg'
            },
            {
                name: 'Nida Rashid',
                date: '04 May, 2025',
                time: '06:00pm',
                text: 'Short city gateway package perfect raha before moving to Hunza.',
                avatar: '/assets/img/blog/comment-author-4.jpg'
            },
            {
                name: 'Furqan Latif',
                date: '05 May, 2025',
                time: '08:40pm',
                text: 'Airport pickup and local sightseeing team ne bohat professionally manage ki.',
                avatar: '/assets/img/blog/comment-author-5.jpg'
            }
        ]
    };

    const destinationRecentPosts = {
        1: [
            { title: 'Best Time to Visit Skardu in Blossom Season', date: '15/3/ 2026', image: '/assets/img/blog/recent-post-1-1.jpg' },
            { title: 'Top 5 Places in Skardu You Should Not Miss', date: '20/3/ 2026', image: '/assets/img/blog/recent-post-1-2.jpg' },
            { title: 'Skardu Family Tour Planning Guide', date: '05/4/ 2026', image: '/assets/img/blog/recent-post-1-3.jpg' }
        ],
        2: [
            { title: 'Hunza Cherry Blossom Complete Travel Guide', date: '12/3/ 2026', image: '/assets/img/blog/recent-post-1-1.jpg' },
            { title: 'Altit and Baltit Fort: Culture of Hunza', date: '22/3/ 2026', image: '/assets/img/blog/recent-post-1-2.jpg' },
            { title: 'Duikar Sunset Viewpoint Tips', date: '02/4/ 2026', image: '/assets/img/blog/recent-post-1-3.jpg' }
        ],
        3: [
            { title: 'Fairy Meadows Trek Difficulty and Preparation', date: '08/5/ 2026', image: '/assets/img/blog/recent-post-1-1.jpg' },
            { title: 'Nanga Parbat Viewpoints You Must Visit', date: '16/5/ 2026', image: '/assets/img/blog/recent-post-1-2.jpg' },
            { title: 'Packing Checklist for Fairy Meadows', date: '25/5/ 2026', image: '/assets/img/blog/recent-post-1-3.jpg' }
        ],
        4: [
            { title: 'Naltar Valley Lakes in Summer Season', date: '09/6/ 2026', image: '/assets/img/blog/recent-post-1-1.jpg' },
            { title: 'Quick 3-Day Naltar Escape Plan', date: '14/6/ 2026', image: '/assets/img/blog/recent-post-1-2.jpg' },
            { title: 'Best Photo Stops in Naltar Valley', date: '19/6/ 2026', image: '/assets/img/blog/recent-post-1-3.jpg' }
        ],
        5: [
            { title: 'Upper Hunza Road Trip to Khunjerab Pass', date: '04/7/ 2026', image: '/assets/img/blog/recent-post-1-1.jpg' },
            { title: 'Attabad Lake and Passu Cones Travel Tips', date: '11/7/ 2026', image: '/assets/img/blog/recent-post-1-2.jpg' },
            { title: 'Best Stops in Gojal Valley', date: '18/7/ 2026', image: '/assets/img/blog/recent-post-1-3.jpg' }
        ],
        6: [
            { title: 'Shigar Fort History and Visitor Guide', date: '03/8/ 2026', image: '/assets/img/blog/recent-post-1-1.jpg' },
            { title: 'Cultural Tour Ideas in Shigar Valley', date: '09/8/ 2026', image: '/assets/img/blog/recent-post-1-2.jpg' },
            { title: 'Skardu + Shigar Combined Itinerary', date: '15/8/ 2026', image: '/assets/img/blog/recent-post-1-3.jpg' }
        ],
        7: [
            { title: 'Deosai National Park Travel Season Guide', date: '10/6/ 2026', image: '/assets/img/blog/recent-post-1-1.jpg' },
            { title: 'Sheosar Lake Day Tour Essentials', date: '17/6/ 2026', image: '/assets/img/blog/recent-post-1-2.jpg' },
            { title: 'High Altitude Safety Tips for Deosai', date: '24/6/ 2026', image: '/assets/img/blog/recent-post-1-3.jpg' }
        ],
        8: [
            { title: 'Nagar Blossom Route and Best Spots', date: '13/3/ 2026', image: '/assets/img/blog/recent-post-1-1.jpg' },
            { title: 'Hopper Valley and Glacier View Guide', date: '21/3/ 2026', image: '/assets/img/blog/recent-post-1-2.jpg' },
            { title: 'Nagar to Hunza Tour Extension Plan', date: '29/3/ 2026', image: '/assets/img/blog/recent-post-1-3.jpg' }
        ],
        9: [
            { title: 'Gilgit City as a Northern Travel Gateway', date: '02/5/ 2026', image: '/assets/img/blog/recent-post-1-1.jpg' },
            { title: 'What to Do in Gilgit in 48 Hours', date: '09/5/ 2026', image: '/assets/img/blog/recent-post-1-2.jpg' },
            { title: 'Gilgit to Hunza Transfer Tips', date: '16/5/ 2026', image: '/assets/img/blog/recent-post-1-3.jpg' }
        ]
    };

    const selectedGallery = destinationGalleries[destinationPost.id] || destinationGalleries[1];
    const selectedReviews = destinationReviews[destinationPost.id] || destinationReviews[1];
    const selectedRecentPosts = destinationRecentPosts[destinationPost.id] || destinationRecentPosts[1];

    const openModal = (imageSrc, event) => {
        event.preventDefault();
        setModalImage(imageSrc);
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);
    return (
        <section className="space">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-8 col-lg-7">
                        <div className="page-single">
                            <div className="service-img">
                                <img src={`/assets/img/destination/${destinationPost.bannerImg}`} alt="" />
                            </div>
                            <div className="page-content d-block">
                                <div className="page-meta mt-50 mb-45">
                                    <Link className="page-tag mr-5" to="/tour">
                                        Featured
                                    </Link>
                                    <span className="ratting">
                                        <i className="fa-sharp fa-solid fa-star" />
                                        <span>4.8</span>
                                    </span>
                                </div>
                                <h2 className="box-title">
                                    {selectedDetails.heading}
                                </h2>
                                <p className="blog-text mb-30">
                                    {selectedDetails.overviewOne}
                                </p>
                                <p className="blog-text mb-35">
                                    {selectedDetails.overviewTwo}
                                </p>
                                <h2 className="box-title">Basic Information</h2>
                                <p className="blog-text mb-35">
                                    {selectedDetails.basicIntro}
                                </p>
                                <div className="destination-checklist">
                                    <div className="checklist style2">
                                        <ul>
                                            <li>Destination</li>
                                            <li>Visa Requirements</li>
                                            <li>Language</li>
                                            <li>Currency Used</li>
                                            <li>Area (km2)</li>
                                            <li>Destination</li>
                                            <li>Per Person</li>
                                        </ul>
                                    </div>
                                    <div className="checklist style2">
                                        <ul>
                                                <li>{destinationPost.title}</li>
                                                <li>Pakistani Citizens â€“ No Visa</li>
                                                <li>Urdu & English</li>
                                                <li>Pakistani Rupee (PKR)</li>
                                                <li>{selectedDetails.area}</li>
                                                <li>{selectedDetails.sitesCount}</li>
                                            <li>{destinationPost.price}</li>
                                        </ul>
                                    </div>
                                </div>
                                <blockquote>
                                    <p>
                                        {selectedDetails.quote}
                                    </p>
                                     <cite>Zahid Hassan â€“ Himolan Peak Adventures</cite>
                                </blockquote>
                                <p className="blog-text mb-35">
                                    Our tours include daily breakfast and dinner, a bonfire/BBQ night, and all entry tickets to major attractions. We travel in luxury Prado/TZ vehicles with a dedicated driver and a professional local guide who knows every hidden trail and viewpoint in the region.
                                </p>
                                <p className="blog-text mb-35">
                                    Whether you're a solo adventurer, a couple on a honeymoon, or a family seeking a memorable holiday, we have a package tailored for you. All timings are flexible and can be adjusted based on weather and group preferences.
                                </p>
                                <h3 className="">
                                    Why Choose Himolan Peak Adventures?
                                </h3>
                                <p className="mb-35">
                                    We are a Skardu-based team with years of on-the-ground experience in Gilgit-Baltistan. Our guides are born and raised in these mountains â€” they know the safest routes, the best viewpoints, and the most authentic local experiences. Safety, comfort, and unforgettable memories are our top priorities on every tour.
                                </p>
                                <div className="service-inner-img mb-40">
                                    <img
                                        src="/assets/img/destination/destination-inner-1.jpg"
                                        alt=""
                                    />
                                </div>
                                <h2 className="box-title">Highlights</h2>
                                <div className="checklist">
                                    <ul>
                                        {selectedDetails.highlights.map((highlight, index) => (
                                            <li key={index}>{highlight}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="destination-gallery-wrapper">
                                <h3 className="page-title mt-30 mb-30">From our gallery</h3>
                                <div className="row gy-4 gallery-row filter-active">
                                    {selectedGallery.map((image, index) => {
                                        const fullPath = `/assets/img/destination/${image}`;
                                        return (
                                            <div key={index} className="col-xxl-auto filter-item">
                                                <div className="gallery-box style3">
                                                    <div className="gallery-img global-img">
                                                        <img
                                                            src={fullPath}
                                                            alt={destinationPost.title}
                                                            onClick={(e) => openModal(fullPath, e)}
                                                        />
                                                        <Link
                                                            to={fullPath}
                                                            className="icon-btn popup-image"
                                                            onClick={(e) => openModal(fullPath, e)}
                                                        >
                                                            <i className="fal fa-magnifying-glass-plus" />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="th-comments-wrap style2 ">
                                <h2 className="blog-inner-title h4">Reviews ({selectedReviews.length})</h2>
                                <ul className="comment-list">
                                    {selectedReviews.map((review, index) => (
                                        <li key={index} className="th-comment-item">
                                            <div className="th-post-comment">
                                                <div className="comment-avater">
                                                    <img src={review.avatar} alt={review.name} />
                                                </div>
                                                <div className="comment-content">
                                                    <h3 className="name">{review.name}</h3>
                                                    <div className="commented-wrapp">
                                                        <span className="commented-on">{review.date}</span>
                                                        <span className="commented-time">{review.time} </span>
                                                        <span className="comment-review">
                                                            <i className="fa-solid fa-star" />
                                                            <i className="fa-solid fa-star" />
                                                            <i className="fa-solid fa-star" />
                                                            <i className="fa-solid fa-star" />
                                                            <i className="fa-solid fa-star" />
                                                        </span>
                                                    </div>
                                                    <p className="text">{review.text}</p>
                                                    <div className="reply_and_edit">
                                                        <i className="fa-solid fa-thumbs-up" />
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>{" "}
                            {/* Comment end */} {/* Comment Form */}
                            <div className="th-comment-form ">
                                <div className="row">
                                    <h3 className="blog-inner-title h4 mb-2">Leave a Reply</h3>
                                    <p className="mb-25">
                                        Your email address will not be published. Required fields are
                                        marked
                                    </p>
                                    <div className="col-md-6 form-group">
                                        <input
                                            type="text"
                                            placeholder="Full Name*"
                                            className="form-control"
                                            required=""
                                        />
                                        <i className="far fa-user" />
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <input
                                            type="text"
                                            placeholder="Your Email*"
                                            className="form-control"
                                            required=""
                                        />
                                        <i className="far fa-envelope" />
                                    </div>
                                    <div className="col-12 form-group">
                                        <input
                                            type="text"
                                            placeholder="Website"
                                            className="form-control"
                                            required=""
                                        />
                                        <i className="far fa-globe" />
                                    </div>
                                    <div className="col-12 form-group">
                                        <textarea
                                            placeholder="Comment*"
                                            className="form-control"
                                            defaultValue={""}
                                        />
                                        <i className="far fa-pencil" />
                                    </div>
                                    <div className="col-12 form-group">
                                        <input type="checkbox" id="html" />
                                        <label htmlFor="html">
                                            Save my name, email, and website in this browser for the next
                                            time I comment.
                                        </label>
                                    </div>
                                    <div className="col-12 form-group mb-0">
                                        <button className="th-btn">
                                            Send Message
                                            <img src="/assets/img/icon/plane2.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-lg-5">
                        <aside className="sidebar-area style3">
                            <div className="widget widget_search  ">
                                <form className="search-form">
                                    <input type="text" placeholder="Search" />
                                    <button type="submit">
                                        <i className="far fa-search" />
                                    </button>
                                </form>
                            </div>
                            <div className="widget widget_categories  ">
                                <h3 className="widget_title">Categories</h3>
                                <ul>
                                    <li>
                                        <Link to="/blog">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                                Mountain Tours
                                        </Link>
                                        <span>(8)</span>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                                Trekking &amp; Hiking
                                        </Link>
                                        <span>(6)</span>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                                Camping &amp; Outdoors
                                        </Link>
                                            <span>(5)</span>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                                Honeymoon Packages
                                        </Link>
                                            <span>(4)</span>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                                Cultural Exploration
                                        </Link>
                                            <span>(3)</span>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                                Customized Packages
                                        </Link>
                                            <span>(9)</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="widget  ">
                                <h3 className="widget_title">Recent Posts</h3>
                                <div className="recent-post-wrap">
                                    {selectedRecentPosts.map((post, index) => (
                                        <div key={index} className="recent-post">
                                            <div className="media-img">
                                                <Link to="/blog/1">
                                                    <img src={post.image} alt="Blog" />
                                                </Link>
                                            </div>
                                            <div className="media-body">
                                                <h4 className="post-title">
                                                    <Link className="text-inherit" to="/blog/1">
                                                        {post.title}
                                                    </Link>
                                                </h4>
                                                <div className="recent-post-meta">
                                                    <Link to="/blog">
                                                        <i className="fa-regular fa-calendar" />
                                                        {post.date}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="widget widget_tag_cloud  ">
                                <h3 className="widget_title">Popular Tags</h3>
                                <div className="tagcloud">
                                    <Link to="/blog">Tour</Link>
                                    <Link to="/blog">Adventure</Link>
                                    <Link to="/blog">Rent</Link>
                                    <Link to="/blog">Innovate</Link>
                                    <Link to="/blog">Hotel</Link>
                                    <Link to="/blog">Modern</Link>
                                    <Link to="/blog">Luxury</Link>
                                    <Link to="/blog">Travel</Link>
                                </div>
                            </div>
                            <div
                                className="widget widget_offer" style={{ background: 'url(/assets/img/bg/widget_bg_1.jpg)', backgroundRepeat: "no-repeat", backgroundSize:"cover" }}
                            >
                                <div className="offer-banner">
                                    <div className="offer">
                                        <h6 className="box-title">
                                            Need Help? We Are Here To Help You
                                        </h6>
                                        <div className="banner-logo">
                                            <img src="/assets/img/primary-logo.png" alt="Himolan Peak Adventures" />
                                        </div>
                                        <div className="offer">
                                            <h6 className="offer-title">You Get Online support</h6>
                                                <Link className="offter-num" to={`tel:${companyInfo.phoneDial}`}>
                                                    {companyInfo.phoneDisplay}
                                            </Link>
                                        </div>
                                        <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style2 th-icon">
                                            Read More
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
            <Modal isOpen={isModalOpen} closeModal={closeModal} imageSrc={modalImage} />
        </section>
    )
}

export default DestinationDetailsMain


